<template>
  <a>
    <slot />
  </a>
</template>
<script lang="ts" setup></script>
